import { initializeApp, getApps } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const requiredEnv = [
  "REACT_APP_FIREBASE_API_KEY",
  "REACT_APP_FIREBASE_AUTH_DOMAIN",
  "REACT_APP_FIREBASE_PROJECT_ID",
  "REACT_APP_FIREBASE_STORAGE_BUCKET",
  "REACT_APP_FIREBASE_MESSAGING_SENDER_ID",
  "REACT_APP_FIREBASE_APP_ID",
];

const missingEnv = requiredEnv.filter((name) => {
  const value = String(process.env[name] || "").trim();
  return !value || value.includes("REPLACE_ME");
});

const apiKey = String(process.env.REACT_APP_FIREBASE_API_KEY || "").trim();
const apiKeyLooksInvalid = apiKey && !apiKey.startsWith("AIza");

if (missingEnv.length || apiKeyLooksInvalid) {
  const details = [
    missingEnv.length
      ? `Missing Firebase env vars: ${missingEnv.join(", ")}`
      : null,
    apiKeyLooksInvalid
      ? "REACT_APP_FIREBASE_API_KEY is invalid (expected a Firebase Web API key starting with 'AIza')."
      : null,
  ]
    .filter(Boolean)
    .join(" ");
  throw new Error(
    `[firebase] ${details} Add Firebase web config to frontend/.env and restart npm start.`
  );
}

const firebaseConfig = {
  apiKey,
  authDomain: String(process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "").trim(),
  projectId: String(process.env.REACT_APP_FIREBASE_PROJECT_ID || "").trim(),
  storageBucket: String(process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "").trim(),
  messagingSenderId: String(process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "").trim(),
  appId: String(process.env.REACT_APP_FIREBASE_APP_ID || "").trim(),
};

export const firebaseApp = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);
export const firebaseAuth = getAuth(firebaseApp);
export const firebaseDb = getFirestore(firebaseApp);
export const firebaseStorage = getStorage(firebaseApp);

